// Counts nodes with non-null value property without optgroups
// noinspection JSMethodCanBeStatic
export function getChildrenLength(children) {
  if (!children) {
    return 0;
  } else if (Array.isArray(children) && children.length) {
    return children.reduce((cnt, { type, props: { value, children: cpc } }) => {
      let count = cnt;
      if (type === 'optgroup') {
        if (cpc) {
          if (Array.isArray(cpc)) {
            cpc.forEach((c) => {
              if (c.props.value) {
                ++count;
              }
            });
          } else if (typeof cpc === 'object' && cpc.props.value) {
            ++count;
          }
        }
      } else if (value || value === 0) {
        ++count;
      }
      return count;
    }, 0);
  } else if (!Array.isArray(children) && typeof children === 'object') {
    if (children.type === 'optgroup') {
      return getChildrenLength(children.props.children);
    } else if (children.props.value) {
      return 1;
    }
  }
  return 0;
}



// WEBPACK FOOTER //
// ./src/common/components/superselectfield/utils.js